import {useDraggable} from "@dnd-kit/core"
import {CSS} from "@dnd-kit/utilities"
import React, {useContext} from "react"
import {Box, IconButton, styled} from "@mui/material"
import {Pencil, Trash} from "lucide-react"
import {ActionContext} from "../../../../src/context/ActionContextProvider"
import {getLabelByItem} from "./drop-area-utils"

export const StyledDndItem = styled(Box)(() => ({
    width: "96px",
    height: "96px",
    boxSizing: "border-box",
    padding: '16px',
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    cursor: 'grab',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}))

const DndItem = ({ id, containerId, item, isInDropArea, position, onRemove, savePointer }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        isDragging,
        transform
    } = useDraggable({
        id: id,
    })

    const {triggerAction} = useContext(ActionContext)

    const onClick = () => {
        triggerAction("OPEN_WUNSCH_MODAL", {item, containerId, savePointer})
    }

    const wrapperSx = isInDropArea
        ? {
            position: "absolute",
            left: position?.x ?? 0,
            top: position?.y ?? 0,
            zIndex: 1
        }
        : { position: "relative" }
    const dragStyle = { transform: CSS.Translate.toString(transform) }

    return (
        <Box sx={{ ...wrapperSx}} style={dragStyle}>
            {isInDropArea && !isDragging && (
                <>
                    <IconButton
                        onClick={onClick}
                        size="small"
                        sx={{
                            position: "absolute",
                            top: -12,
                            right: 21,
                            zIndex: 2,
                            backgroundColor: "#fff",
                            border: "1px solid #e0e0e0",
                            padding: "4px",
                        }}
                    >
                        <Pencil width="18px" height="18px" />
                    </IconButton>
                    <IconButton
                        onClick={() => onRemove(id)}
                        size="small"
                        sx={{
                            position: "absolute",
                            top: -12,
                            right: -12,
                            zIndex: 2,
                            backgroundColor: "#fff",
                            border: "1px solid #e0e0e0",
                            padding: "4px",
                        }}
                    >
                        <Trash width="18px" height="18px" />
                    </IconButton>
                </>
            )}
            <StyledDndItem
                sx={{ visibility: isDragging && !isInDropArea ? "hidden" : "visible" }}
                ref={setNodeRef}
                {...listeners}
                {...attributes}
            >
                {getLabelByItem(item)}
            </StyledDndItem>
        </Box>
    )
}

export default DndItem